export function dateReviver(_: string, value: unknown): unknown {
  const dateRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
  if (typeof value == 'string' && dateRegex.test(value)) {
    return new Date(value).getTime();
  }
  return value;
}
